/* import __COLOCATED_TEMPLATE__ from './sh-payment-transactions-list.hbs'; */
import Component from '@ember/component';
import { showModal } from "sh-www/utils/modal-controls";

/**
 * This is the list of all of the transactions for the ShPayment
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['SH-c-sh-payment-transactions-list'],

  /**
   * Register services
   */

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /**
   * @param {Function}     Called after we have successfully edited a transaction
   */
  onTransactionEdited: (shPaymentTransaction) => {},

  /** @type {Function} */
  onTransactionDeleted: undefined,

  /**
   * @param {ShPayment}
   */
  shPayment: null,

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  actions: {
    /**
     *
     */
    onMarkPaidClicked: function() {
      let modalModel = {
        shPayment: this.get('shPayment'),
        shPaymentTransaction: null,
        onTransactionEdited: () => {
          this.get('onTransactionEdited')();
        }
      };

      showModal(this, 'admin/edit-sh-payment-transaction-modal', modalModel);
    }
  }
});
